/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_LeadInputs */



/**
* | output |
* | --- |
* | "Answer four questions and the form below is filled in for your kind of event." |
*
* @param {Tournament_Wiz_LeadInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_lead = /** @type {((inputs?: Tournament_Wiz_LeadInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_LeadInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Répondez à quatre questions et le formulaire ci-dessous est prérempli pour votre type de tournoi.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Responda cuatro preguntas y el formulario de abajo se rellena para su tipo de torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Responda quatro perguntas e o formulário abaixo é preenchido para o seu tipo de torneio.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rispondi a quattro domande e il modulo qui sotto si compila per il tuo tipo di torneo.")
	return /** @type {LocalizedString} */ ("Answer four questions and the form below is filled in for your kind of event.")
});